(() => {
  const safelyRead = (key) => {
    try { return window.localStorage.getItem(key); } catch (_) { return null; }
  };

  const safelyWrite = (key, value) => {
    try { window.localStorage.setItem(key, value); } catch (_) { /* Storage can be disabled. */ }
  };

  const format = (value) => String(Math.max(0, value)).padStart(2, '0');

  const startCountdown = (timer) => {
    const endsAt = Date.parse(timer.dataset.endAt || '');
    const campaign = timer.closest('[data-entina-campaign]');
    if (!Number.isFinite(endsAt)) {
      timer.hidden = true;
      return;
    }

    let interval;
    const update = () => {
      const remaining = endsAt - Date.now();
      if (remaining <= 0) {
        if (campaign?.dataset.hideOnEnd === 'true') campaign.hidden = true;
        window.clearInterval(interval);
        return;
      }
      const seconds = Math.floor(remaining / 1000);
      const values = {
        days: Math.floor(seconds / 86400),
        hours: Math.floor((seconds % 86400) / 3600),
        minutes: Math.floor((seconds % 3600) / 60),
        seconds: seconds % 60
      };
      Object.entries(values).forEach(([unit, value]) => {
        const target = timer.querySelector(`[data-countdown-${unit}]`);
        if (target) target.textContent = format(value);
      });
    };

    update();
    interval = window.setInterval(update, 1000);
  };

  const copyCode = async (code) => {
    if (!code) return false;
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(code);
      return true;
    }
    const input = document.createElement('textarea');
    input.value = code;
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.append(input);
    input.select();
    const copied = document.execCommand('copy');
    input.remove();
    return copied;
  };

  const bindCouponCopy = (button) => {
    button.addEventListener('click', async () => {
      try {
        if (!await copyCode(button.dataset.entinaCopyCode)) return;
        const copied = button.dataset.copiedText || 'Copied';
        button.textContent = copied;
        window.setTimeout(() => { button.textContent = button.dataset.defaultText || 'Copy code'; }, 2400);
      } catch (_) {
        button.textContent = 'Copy unavailable';
      }
    });
  };

  const initPopup = (popup) => {
    const endAt = popup.dataset.campaignEnd || '';
    const key = `entina:promotion-popup-dismissed:${endAt}`;
    if (safelyRead(key)) return;
    const endAtMs = Date.parse(endAt);
    if (!Number.isFinite(endAtMs) || endAtMs <= Date.now()) return;

    let ready = false;
    let shown = false;
    const scrollDepth = Number(popup.dataset.scrollDepth || 25);
    const show = () => {
      if (shown || !ready || safelyRead(key)) return;
      const maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      const hasScrolled = window.scrollY >= 180 && (window.scrollY / maxScroll) * 100 >= scrollDepth;
      if (!hasScrolled) return;
      shown = true;
      popup.hidden = false;
      window.setTimeout(() => popup.querySelector('input[type="email"]')?.focus(), 0);
    };
    const close = () => {
      popup.hidden = true;
      safelyWrite(key, '1');
      document.removeEventListener('keydown', onKeyDown);
    };
    const onKeyDown = (event) => { if (event.key === 'Escape') close(); };

    popup.querySelectorAll('[data-entina-close-popup]').forEach((button) => button.addEventListener('click', close));
    document.addEventListener('keydown', onKeyDown);
    window.addEventListener('scroll', show, { passive: true });
    window.setTimeout(() => { ready = true; show(); }, Number(popup.dataset.delaySeconds || 20) * 1000);
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-entina-countdown]').forEach(startCountdown);
    document.querySelectorAll('[data-entina-copy-code]').forEach(bindCouponCopy);
    document.querySelectorAll('[data-entina-dismiss-banner]').forEach((button) => {
      const campaign = button.closest('[data-entina-campaign]');
      const key = `entina:promotion-banner-dismissed:${campaign?.dataset.campaignEnd || 'campaign'}`;
      if (safelyRead(key) && campaign) campaign.hidden = true;
      button.addEventListener('click', () => {
        if (campaign) campaign.hidden = true;
        safelyWrite(key, '1');
      });
    });
    document.querySelectorAll('[data-entina-promotion-popup]').forEach(initPopup);
  });
})();
